import React from 'react';
import { Row, Col, Input } from 'antd';
import { FiSearch } from 'react-icons/fi';
import i18n from 'i18next';

export interface SearchParams {
  handleFieldChange: (e: any) => void;
}

export const Search: React.FC<SearchParams> = ({ handleFieldChange }) => {
  return (
    <div className="search-cards-container">
      <Row className="search-container">
        <Col span={24}>
          <Input
            placeholder={i18n.t('SEARCH_FOR')}
            prefix={<FiSearch color="#939393" size={18} />}
            className="input-search"
            onChange={handleFieldChange}
          />
        </Col>
      </Row>
    </div>
  );
};
